import { EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { IAuthCommon, IAuthTable } from './auth.interfaces';
import { AuthActions, AuthActionTypes } from './auth.actions';

export const authAdapter: EntityAdapter<IAuthCommon> = createEntityAdapter<
  IAuthCommon
>();

export function authInitState(): IAuthTable {
  return authAdapter.getInitialState({});
}

export function authReducer(state = authInitState(), action: AuthActions) {
  switch (action.type) {
    case AuthActionTypes.LOGIN_SUCCESS:
    case AuthActionTypes.REFRESH_TOKEN_SUCCESS:

      return {
        ...state,
        ...action.payload,
      };

    case AuthActionTypes.LOGOUT:
      return authInitState();

    default:
      return state;
  }
}
